const actions = {
  CREATE_MEMBER_RECYCLE: 'CREATE_MEMBER_RECYCLE',
  CREATE_MEMBER_RECYCLE_ENDED: 'CREATE_MEMBER_RECYCLE_ENDED',
  SEARCH_MEMBER_RECYCLES: 'SEARCH_MEMBER_RECYCLES',
  SEARCH_MEMBER_RECYCLES_ENDED: 'SEARCH_MEMBER_RECYCLES_ENDED',
  UPDATE_MEMBER_RECYCLE: 'UPDATE_MEMBER_RECYCLE',
  UPDATE_MEMBER_RECYCLE_ENDED: 'UPDATE_MEMBER_RECYCLE_ENDED',
  DELETE_MEMBER_RECYCLES: 'DELETE_MEMBER_RECYCLES',
  DELETE_MEMBER_RECYCLES_ENDED: 'DELETE_MEMBER_RECYCLES_ENDED',
  TRIGGER_MEMBER_RECYCLE: 'TRIGGER_MEMBER_RECYCLE',
  TRIGGER_MEMBER_RECYCLE_ENDED: 'TRIGGER_MEMBER_RECYCLE_ENDED',
  SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS: 'SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS',
  SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS_ENDED: 'SEARCH_MEMBER_RECYCLE_MEMBER_RECORDS_ENDED',
  SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS: 'SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS',
  SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS_ENDED: 'SEARCH_MEMBER_RECYCLE_TRIGGER_RECORDS_ENDED',
  GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS: 'GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS',
  GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS_ENDED:
    'GET_MEMBER_RECYCLE_TRIGGER_RECORD_STATISTICS_ENDED',
};

export default actions;
